export const caseService = (client) => {
    let _client = client
    let _id

    return {
        all: async () => {
            return await client.get(`${process.env.VUE_APP_API_URL}/cases`)
        },

        whereId (id) {_id = id; return this},

        get: async () => {
            return await client.get(`${process.env.VUE_APP_API_URL}/cases/${_id}`)
        },

        mapCaseFieldsToAnswers: claim => {
            return claim.form.fields.map(field => {
                return { id: field.id, title: field.title }
            }).map(field => {
                let answer = claim.response.answers.find(answer => answer.field.id === field.id)
                return { ...field, answer }
            })
        }
    }
}